import React from "react";
import PropTypes from "prop-types";
import { isEmpty as _isEmpty } from "lodash-es";
import { TrashIcon } from "@heroicons/react/solid";
import { useHistory } from "react-router";

import { Modal, ModalBody, ModalTitle } from "../../components/Modal";
import Avatar from "../../components/Avatar";
import EmptyResult from "../../components/EmptyResult";
import { getHumanUrl } from "../../utils";

export default function MemberListModal({
  members,
  circleName,
  closeModal,
  removeHuman,
  circleId,
}) {
  const history = useHistory();
  function removeMember(memberId) {
    if (
      window.confirm(
        `Are you sure you want to remove this human from ${circleName}?`
      )
    ) {
      removeHuman(memberId, circleId);
    }
  }

  function goToHumansPage(member) {
    history.push({
      pathname: getHumanUrl({ id: member.id, name: member.name }),
    });
  }

  return (
    <Modal focusElement={null} isOpened={true} onClose={closeModal}>
      <ModalTitle>{circleName}</ModalTitle>
      <ModalBody>
        <div className="mt-2 h-96 overflow-y-auto">
          {_isEmpty(members) ? (
            <EmptyResult>No aren't any humans in this circle yet</EmptyResult>
          ) : (
            <ul className="divide-y divide-gray-200">
              {members.map((member, key) => (
                <li
                  onClick={() => goToHumansPage(member)}
                  key={key}
                  className="py-4 pr-4 pl-4 flex cursor-pointer"
                >
                  <Avatar human={member} isEditable={false} size="45px" />
                  <div className="ml-3">
                    <p className="text-sm font-medium text-gray-900">
                      {member.name}
                    </p>
                  </div>
                  <div className="ml-auto">
                    <TrashIcon
                      className="text-gray-200 h-5 w-5 cursor-pointer ml-2 hover:text-gray-400"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeMember(member.id);
                      }}
                    />
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
}

MemberListModal.propTypes = {
  members: PropTypes.array.isRequired,
  circleName: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  removeHuman: PropTypes.func.isRequired,
  circleId: PropTypes.any.isRequired,
};
